"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = embedDataToHtml;
exports.nodeToHtml = void 0;

var _embed = require("../constants/embed");

var _xssTransform = require("../lib/xssTransform");

var _parseHTML = _interopRequireDefault(require("./parseHTML"));

var nodeToHtml = function nodeToHtml(node, ignoreScripts) {
  if (node.tag === 'text') {
    return node.content;
  }

  var _node$attributes = node.attributes,
      attributes = _node$attributes === void 0 ? [] : _node$attributes,
      children = node.children,
      tag = node.tag;

  if (tag === 'script' && ignoreScripts || _embed.ignoreTags.includes(tag)) {
    return '';
  }

  var element = document.createElement(tag);
  attributes.forEach(function (_ref) {
    var key = _ref.key,
        _ref$value = _ref.value,
        value = _ref$value === void 0 ? '' : _ref$value;

    try {
      element.setAttribute(key, value);
    } catch (e) {
      console.error(e);
    }
  });

  if (!_embed.selfClosingTags.includes(tag)) {
    // eslint-disable-next-line no-use-before-define
    element.innerHTML = embedDataToHtml(children);
  }

  return element.outerHTML;
};

exports.nodeToHtml = nodeToHtml;

function embedDataToHtml(data) {
  var ignoreScripts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!data) {
    return '';
  } // Legacy format


  if (!Array.isArray(data)) {
    var allowFullscreen = data.allowFullscreen ? 'allowFullscreen="1"' : '';
    return "<iframe src=\"" + data.src + "\" width=\"" + data.width + "\" height=\"" + data.height + "\" " + allowFullscreen + " data-service=\"" + data.service + "\" frameborder=\"0\"></iframe>";
  }

  var rawHtml = data.reduce(function (html, node) {
    var cleanHtml = nodeToHtml(node, ignoreScripts);
    return "" + html + cleanHtml;
  }, '');
  var body = (0, _parseHTML.default)(rawHtml);

  if (body === null) {
    return null;
  }

  (0, _xssTransform.xssTransformIn)(body, false);
  return body.innerHTML;
}